import panel from '@/views/product/views/panel/panel';
export default panel;